import { useState, useEffect } from "react";

interface SplashScreenProps {
  onComplete: () => void;
}

const SplashScreen = ({ onComplete }: SplashScreenProps) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isFadingOut, setIsFadingOut] = useState(false);

  useEffect(() => {
    // Display splash for 2 seconds, then fade out
    const displayTimeout = setTimeout(() => {
      setIsFadingOut(true);
    }, 2000);

    return () => {
      clearTimeout(displayTimeout);
    };
  }, []);

  useEffect(() => {
    if (isFadingOut) {
      // After fade animation completes, call onComplete
      const fadeTimeout = setTimeout(() => {
        setIsVisible(false);
        onComplete();
      }, 500); // Match the animation duration

      return () => clearTimeout(fadeTimeout);
    }
  }, [isFadingOut, onComplete]);

  if (!isVisible) {
    return null;
  }

  return (
    <div 
      className={`fixed inset-0 z-[9999] bg-background flex items-center justify-center transition-opacity duration-500 ${
        isFadingOut ? 'opacity-0' : 'opacity-100'
      }`}
    >
      <img
        src="/splash-image.jpg"
        alt="SiteBook - Campsite Management Simplified"
        className="w-full h-full object-cover"
      />
    </div>
  );
};

export default SplashScreen;
